import React from 'react';

const team = [
  {
    name: 'Anurag Tripathi',
    role: 'Founder & CEO',
    photo: 'https://customer-assets-v7afamib.emergentagent.net/job_kytemoney-style/artifacts/vfezymmv_Anurag%20Tripathi.png',
  },
  {
    name: 'Sriragh Radhakrishnan',
    role: 'Partner, Strategic Relationships',
    photo: 'https://customer-assets-v7afamib.emergentagent.net/job_kytemoney-style/artifacts/2i07cvy8_Sriragh%20Radhakrishnan.png',
  },
  {
    name: 'Devendra Singh',
    role: 'Partner, Business Development',
    photo: 'https://customer-assets-v7afamib.emergentagent.net/job_kytemoney-style/artifacts/j8fupkgb_Devendra%20Singh.png',
  },
];

export default function Team() {
  return (
    <section id="team" className="px-4 md:px-6 pt-6 md:pt-8">
      <div className="max-w-7xl mx-auto bg-white rounded-[32px] md:rounded-[40px] px-6 md:px-12 py-20 md:py-28 border border-neutral-200">
        <div className="text-center reveal">
          <span className="inline-block text-[11px] font-semibold tracking-[0.2em] uppercase text-neutral-800 bg-neutral-100 border border-neutral-200 px-3 py-1.5 rounded-full">
            Team
          </span>
          <h2 className="font-display-bold mt-6 text-4xl md:text-[64px] leading-[1.05] text-neutral-900">
            Meet the <span className="relative inline-block">
              <span className="relative z-10">team</span>
              <span className="absolute -inset-x-1 bottom-1 md:bottom-2 h-2 md:h-4 -z-0 rounded bg-[#E8DBC6]" />
            </span>
          </h2>
          <p className="mt-6 max-w-2xl mx-auto text-neutral-600 text-base md:text-lg">
            One team, supported by 50+ specialist partners.
          </p>
        </div>

        <div className="mt-14 md:mt-20 grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {team.map((member, i) => (
            <div
              key={member.name}
              className="card-hover reveal relative rounded-[28px] p-5 md:p-6 bg-neutral-50 border border-neutral-200 flex flex-col"
              style={{ transitionDelay: `${i * 90}ms` }}
            >
              {/* Photo */}
              <div className="aspect-[4/5] w-full rounded-[20px] overflow-hidden relative bg-neutral-100">
                <img
                  src={member.photo}
                  alt={member.name}
                  loading="lazy"
                  className="absolute inset-0 w-full h-full object-cover"
                />
              </div>

              {/* Details */}
              <div className="mt-6 px-1">
                <h3 className="font-display-bold text-[22px] md:text-[24px] leading-tight text-neutral-900">
                  {member.name}
                </h3>
                <p className="mt-1.5 text-[14px] text-neutral-600">
                  {member.role}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
